var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDynamic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(315 510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(-315 -510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    d: "M-231.106-508.621a14.11 14.11 0 0 1 10.432 4.292 14.113 14.113 0 0 1 4.294 10.435v67.788a14.691 14.691 0 0 1-3.991 10.47c-2.665 2.864-6.177 4.257-10.736 4.257h-67.784a14.049 14.049 0 0 1-10.436-4.3 14.047 14.047 0 0 1-4.294-10.432v-67.788a14.076 14.076 0 0 1 4.3-10.434 14.074 14.074 0 0 1 10.433-4.293h67.784m0-1.379h-67.784a15.536 15.536 0 0 0-11.409 4.7 15.53 15.53 0 0 0-4.7 11.409v67.788a15.5 15.5 0 0 0 4.7 11.409 15.5 15.5 0 0 0 11.409 4.7h67.784q7.378 0 11.746-4.7A16.162 16.162 0 0 0-215-426.106v-67.788a15.573 15.573 0 0 0-4.7-11.409 15.573 15.573 0 0 0-11.409-4.7z",
    fill: "#ff7557",
    "data-name": "Path 915",
    transform: "translate(315 510)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069",
    transform: "translate(-297.518 -494.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(15.993 23.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    d: "M-192.844-376.6H-213.1a4.833 4.833 0 0 1-4.828-4.828v-11.9a4.833 4.833 0 0 1 4.828-4.828h20.252a4.833 4.833 0 0 1 4.828 4.828v11.9a4.833 4.833 0 0 1-4.824 4.828zm-20.256-20.168a3.452 3.452 0 0 0-3.448 3.448v11.9a3.452 3.452 0 0 0 3.448 3.448h20.252a3.452 3.452 0 0 0 3.448-3.448v-11.9a3.452 3.452 0 0 0-3.448-3.448z",
    fill: "#ff7557",
    "data-name": "Path 916",
    transform: "translate(217.923 398.147)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(20.957 28.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    d: "M-184.238-381.575h-18.6a.689.689 0 0 1-.69-.69.69.69 0 0 1 .69-.69h18.6a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 917",
    transform: "translate(203.527 382.954)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(20.957 33.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    d: "M-184.238-367.141h-18.6a.689.689 0 0 1-.69-.69.69.69 0 0 1 .69-.69h18.6a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 918",
    transform: "translate(203.527 368.52)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(20.957 38.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    d: "M-191.835-352.706h-11a.69.69 0 0 1-.69-.69.689.689 0 0 1 .69-.69h11a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 919",
    transform: "translate(203.527 354.085)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023",
    transform: "translate(30.388 13.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    d: "M-175.488-415.682a.69.69 0 0 1-.69-.69v-9.955a.69.69 0 0 1 .69-.69.69.69 0 0 1 .69.69v9.955a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 920",
    transform: "translate(176.178 427.016)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(28.292 8.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    d: "M-179.47-433.6a2.788 2.788 0 0 1-2.786-2.785 2.788 2.788 0 0 1 2.786-2.785 2.788 2.788 0 0 1 2.785 2.785 2.788 2.788 0 0 1-2.785 2.785zm0-4.191a1.408 1.408 0 0 0-1.406 1.406 1.408 1.408 0 0 0 1.406 1.406 1.407 1.407 0 0 0 1.406-1.406 1.407 1.407 0 0 0-1.406-1.406z",
    fill: "#ff7557",
    "data-name": "Path 921",
    transform: "translate(182.256 439.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(42.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    d: "M-138.447-459.429a2.788 2.788 0 0 1-2.786-2.785 2.789 2.789 0 0 1 2.786-2.786 2.788 2.788 0 0 1 2.785 2.786 2.788 2.788 0 0 1-2.785 2.785zm0-4.191a1.408 1.408 0 0 0-1.406 1.406 1.408 1.408 0 0 0 1.406 1.406 1.407 1.407 0 0 0 1.406-1.406 1.408 1.408 0 0 0-1.406-1.407z",
    fill: "#ff7557",
    "data-name": "Path 922",
    transform: "translate(141.233 465)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026",
    transform: "translate(55.798 26.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    d: "M-99.7-383.46a2.788 2.788 0 0 1-2.785-2.786 2.788 2.788 0 0 1 2.785-2.785 2.788 2.788 0 0 1 2.786 2.785 2.789 2.789 0 0 1-2.786 2.786zm0-4.191a1.407 1.407 0 0 0-1.406 1.406 1.408 1.408 0 0 0 1.406 1.405 1.408 1.408 0 0 0 1.406-1.406 1.408 1.408 0 0 0-1.406-1.406z",
    fill: "#ff7557",
    "data-name": "Path 923",
    transform: "translate(102.488 389.031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    transform: "translate(48.463 44.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    d: "M-120.974-331.8a2.789 2.789 0 0 1-2.786-2.785 2.789 2.789 0 0 1 2.786-2.786 2.788 2.788 0 0 1 2.785 2.786 2.788 2.788 0 0 1-2.785 2.785zm0-4.191a1.408 1.408 0 0 0-1.406 1.406 1.408 1.408 0 0 0 1.406 1.406 1.407 1.407 0 0 0 1.406-1.406 1.408 1.408 0 0 0-1.406-1.408z",
    fill: "#ff7557",
    "data-name": "Path 924",
    transform: "translate(123.76 337.372)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028",
    transform: "translate(44.533 61.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    d: "M-132.37-281.662a2.788 2.788 0 0 1-2.785-2.785 2.788 2.788 0 0 1 2.785-2.785 2.788 2.788 0 0 1 2.786 2.785 2.788 2.788 0 0 1-2.786 2.785zm0-4.191a1.407 1.407 0 0 0-1.406 1.406 1.408 1.408 0 0 0 1.406 1.406 1.408 1.408 0 0 0 1.406-1.406 1.408 1.408 0 0 0-1.406-1.406z",
    fill: "#ff7557",
    "data-name": "Path 925",
    transform: "translate(135.155 287.232)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029",
    transform: "translate(23.314 63.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    d: "M-193.9-275.584a2.789 2.789 0 0 1-2.786-2.786 2.788 2.788 0 0 1 2.786-2.785 2.788 2.788 0 0 1 2.785 2.785 2.788 2.788 0 0 1-2.785 2.786zm0-4.191a1.408 1.408 0 0 0-1.406 1.406 1.408 1.408 0 0 0 1.406 1.406 1.408 1.408 0 0 0 1.406-1.406 1.407 1.407 0 0 0-1.406-1.407z",
    fill: "#ff7557",
    "data-name": "Path 926",
    transform: "translate(196.69 281.155)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(13.884 56.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    d: "M-221.253-294.576a2.789 2.789 0 0 1-2.786-2.786 2.788 2.788 0 0 1 2.786-2.785 2.788 2.788 0 0 1 2.785 2.785 2.788 2.788 0 0 1-2.785 2.786zm0-4.191a1.408 1.408 0 0 0-1.406 1.406 1.408 1.408 0 0 0 1.406 1.406 1.408 1.408 0 0 0 1.406-1.406 1.407 1.407 0 0 0-1.406-1.407z",
    fill: "#ff7557",
    "data-name": "Path 927",
    transform: "translate(224.039 300.147)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031",
    transform: "translate(0 31.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    d: "M-261.517-369.026a2.788 2.788 0 0 1-2.785-2.786 2.788 2.788 0 0 1 2.785-2.785 2.789 2.789 0 0 1 2.786 2.785 2.789 2.789 0 0 1-2.786 2.786zm0-4.191a1.407 1.407 0 0 0-1.406 1.406 1.408 1.408 0 0 0 1.406 1.406 1.408 1.408 0 0 0 1.406-1.406 1.408 1.408 0 0 0-1.406-1.407z",
    fill: "#ff7557",
    "data-name": "Path 928",
    transform: "translate(264.302 374.597)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    transform: "translate(0 12.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    d: "M-261.517-422.2a2.788 2.788 0 0 1-2.785-2.786 2.788 2.788 0 0 1 2.785-2.785 2.788 2.788 0 0 1 2.786 2.785 2.789 2.789 0 0 1-2.786 2.786zm0-4.191a1.407 1.407 0 0 0-1.406 1.406 1.408 1.408 0 0 0 1.406 1.406 1.408 1.408 0 0 0 1.406-1.406 1.408 1.408 0 0 0-1.406-1.415z",
    fill: "#ff7557",
    "data-name": "Path 929",
    transform: "translate(264.302 427.775)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    transform: "translate(48.463 15.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    d: "M-120.974-413.088a2.789 2.789 0 0 1-2.786-2.786 2.789 2.789 0 0 1 2.786-2.785 2.788 2.788 0 0 1 2.785 2.785 2.788 2.788 0 0 1-2.785 2.786zm0-4.191a1.408 1.408 0 0 0-1.406 1.406 1.408 1.408 0 0 0 1.406 1.406 1.408 1.408 0 0 0 1.406-1.406 1.407 1.407 0 0 0-1.406-1.407z",
    fill: "#ff7557",
    "data-name": "Path 930",
    transform: "translate(123.76 418.659)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    transform: "translate(13.884 2.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    d: "M-221.253-453.352a2.788 2.788 0 0 1-2.786-2.785 2.788 2.788 0 0 1 2.786-2.785 2.788 2.788 0 0 1 2.785 2.785 2.788 2.788 0 0 1-2.785 2.785zm0-4.191a1.408 1.408 0 0 0-1.406 1.406 1.408 1.408 0 0 0 1.406 1.406 1.407 1.407 0 0 0 1.406-1.406 1.407 1.407 0 0 0-1.406-1.406z",
    fill: "#ff7557",
    "data-name": "Path 931",
    transform: "translate(224.039 458.922)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035",
    transform: "translate(23.314 17.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    d: "M-196-407.718a.69.69 0 0 1-.69-.69v-5.763a.69.69 0 0 1 .69-.69.689.689 0 0 1 .69.69v5.763a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 932",
    transform: "translate(196.69 414.86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036",
    transform: "translate(15.98 17.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    d: "M-209.937-413.481h-7.335a.69.69 0 0 1-.69-.69.689.689 0 0 1 .69-.69h7.335a.689.689 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 933",
    transform: "translate(217.961 414.86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037",
    transform: "translate(15.98 6.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    d: "M-217.271-434.386a.69.69 0 0 1-.69-.69v-11a.69.69 0 0 1 .69-.69.69.69 0 0 1 .69.69v11a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 934",
    transform: "translate(217.961 446.768)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    transform: "translate(7.073 4.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    d: "M-236.29-451.466h-6.81a.69.69 0 0 1-.69-.69.69.69 0 0 1 .69-.69h6.811a.69.69 0 0 1 .69.69.689.689 0 0 1-.691.69z",
    fill: "#ff7557",
    "data-name": "Path 935",
    transform: "translate(243.791 452.845)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(37.46 11.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    d: "M-154.977-419.663a.69.69 0 0 1-.69-.69V-432.4a.69.69 0 0 1 .69-.69.689.689 0 0 1 .69.69v12.05a.69.69 0 0 1-.69.687z",
    fill: "#ff7557",
    "data-name": "Path 936",
    transform: "translate(155.667 433.093)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "translate(37.46 11.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    d: "M-137.688-431.714h-17.29a.69.69 0 0 1-.69-.69.69.69 0 0 1 .69-.69h17.29a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 937",
    transform: "translate(155.667 433.093)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    transform: "translate(44.533 28.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    d: "M-123.2-381.575h-11.264a.689.689 0 0 1-.69-.69.69.69 0 0 1 .69-.69h11.264a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 938",
    transform: "translate(135.155 382.954)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "translate(57.893 18.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    d: "M-95.721-403.082a.69.69 0 0 1-.69-.69v-8.121a.69.69 0 0 1 .69-.69.69.69 0 0 1 .69.69v8.121a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 939",
    transform: "translate(96.411 412.582)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(57.893 18.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    d: "M-89.958-411.2h-5.763a.69.69 0 0 1-.69-.69.69.69 0 0 1 .69-.69h5.763a.69.69 0 0 1 .69.69.689.689 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 940",
    transform: "translate(96.411 412.582)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044",
    transform: "translate(50.559 20.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    d: "M-116.992-397a.689.689 0 0 1-.69-.69v-8.121a.69.69 0 0 1 .69-.69.69.69 0 0 1 .69.69v8.121a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 941",
    transform: "translate(117.682 406.504)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045",
    transform: "translate(54.75 7.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    d: "M-104.837-438.184a.69.69 0 0 1-.69-.69v-3.406a.69.69 0 0 1 .69-.69.69.69 0 0 1 .69.69v3.406a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 942",
    transform: "translate(105.527 442.969)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046",
    transform: "translate(44.533 4.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    d: "M-134.465-444.655a.69.69 0 0 1-.69-.69v-6.811a.69.69 0 0 1 .69-.69.69.69 0 0 1 .69.69v6.811a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 943",
    transform: "translate(135.155 452.845)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(44.533 35.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    d: "M-124.249-359.543h-10.217a.69.69 0 0 1-.69-.69.689.689 0 0 1 .69-.69h10.217a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 944",
    transform: "translate(135.155 360.922)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(55.012 35.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    d: "M-104.077-352.208a.69.69 0 0 1-.69-.69v-7.335a.689.689 0 0 1 .69-.69.69.69 0 0 1 .69.69v7.335a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 945",
    transform: "translate(104.767 360.922)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049",
    transform: "translate(55.012 43.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    d: "M-95.433-338.272h-8.644a.69.69 0 0 1-.69-.69.689.689 0 0 1 .69-.69h8.644a.689.689 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 946",
    transform: "translate(104.767 339.651)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050",
    transform: "translate(39.556 43.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    d: "M-148.9-328.579a.69.69 0 0 1-.69-.69v-9.693a.689.689 0 0 1 .69-.69.69.69 0 0 1 .69.69v9.693a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 947",
    transform: "translate(149.589 339.651)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051",
    transform: "translate(39.556 52.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    d: "M-130.562-310.163H-148.9a.69.69 0 0 1-.69-.69.689.689 0 0 1 .69-.69h18.337a.689.689 0 0 1 .69.69.69.69 0 0 1-.689.69z",
    fill: "#ff7557",
    "data-name": "Path 948",
    transform: "translate(149.589 311.542)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(50.559 48.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    d: "M-116.992-319.122a.69.69 0 0 1-.69-.69v-4.716a.689.689 0 0 1 .69-.69.69.69 0 0 1 .69.69v4.716a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 949",
    transform: "translate(117.682 325.217)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    transform: "translate(57.893 52.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    d: "M-95.721-302.566a.69.69 0 0 1-.69-.69v-7.6a.69.69 0 0 1 .69-.69.689.689 0 0 1 .69.69v7.6a.689.689 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 950",
    transform: "translate(96.411 311.542)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054",
    transform: "translate(30.388 43.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    d: "M-175.488-324.65a.69.69 0 0 1-.69-.69v-13.622a.689.689 0 0 1 .69-.69.69.69 0 0 1 .69.69v13.622a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 951",
    transform: "translate(176.178 339.651)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055",
    transform: "translate(25.41 56.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    d: "M-179.968-298.768h-9.954a.69.69 0 0 1-.69-.69.689.689 0 0 1 .69-.69h9.954a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 952",
    transform: "translate(190.612 300.147)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(35.365 56.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    d: "M-161.054-292.219a.69.69 0 0 1-.69-.69v-6.549a.689.689 0 0 1 .69-.69.69.69 0 0 1 .69.69v6.549a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 953",
    transform: "translate(161.744 300.147)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057",
    transform: "translate(25.41 56.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    d: "M-189.922-292.219a.69.69 0 0 1-.69-.69v-6.549a.689.689 0 0 1 .69-.69.69.69 0 0 1 .69.69v6.549a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 954",
    transform: "translate(190.612 300.147)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058",
    transform: "translate(35.365 63.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    d: "M-151.886-279.776h-9.169a.69.69 0 0 1-.69-.69.689.689 0 0 1 .69-.69h9.169a.689.689 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 955",
    transform: "translate(161.744 281.155)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059",
    transform: "translate(15.98 50.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    d: "M-202.863-318.52h-14.408a.69.69 0 0 1-.69-.69.689.689 0 0 1 .69-.69h14.408a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 956",
    transform: "translate(217.961 319.899)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "translate(15.98 50.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    d: "M-217.271-311.709a.69.69 0 0 1-.69-.69v-6.811a.689.689 0 0 1 .69-.69.69.69 0 0 1 .69.69v6.811a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 957",
    transform: "translate(217.961 319.899)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061",
    transform: "translate(4.191 33.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    d: "M-239.669-367.141h-11.788a.689.689 0 0 1-.69-.69.69.69 0 0 1 .69-.69h11.788a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 958",
    transform: "translate(252.147 368.52)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062",
    transform: "translate(9.431 33.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    d: "M-236.263-354.3a.69.69 0 0 1-.69-.69v-12.84a.69.69 0 0 1 .69-.69.69.69 0 0 1 .69.69v12.837a.69.69 0 0 1-.69.693z",
    fill: "#ff7557",
    "data-name": "Path 959",
    transform: "translate(236.953 368.52)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063",
    transform: "translate(2.096 46.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    d: "M-250.2-329.915h-7.335a.69.69 0 0 1-.69-.69.69.69 0 0 1 .69-.69h7.335a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 960",
    transform: "translate(258.225 331.294)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064",
    transform: "translate(2.096 46.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    d: "M-257.535-322.58a.69.69 0 0 1-.69-.69v-7.33a.69.69 0 0 1 .69-.69.689.689 0 0 1 .69.69v7.335a.69.69 0 0 1-.69.685z",
    fill: "#ff7557",
    "data-name": "Path 961",
    transform: "translate(258.225 331.294)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065",
    transform: "translate(9.431 28.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    d: "M-229.714-381.575h-6.549a.689.689 0 0 1-.69-.69.69.69 0 0 1 .69-.69h6.549a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 962",
    transform: "translate(236.953 382.954)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(9.431 20.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    d: "M-236.263-397a.689.689 0 0 1-.69-.69v-8.121a.69.69 0 0 1 .69-.69.69.69 0 0 1 .69.69v8.121a.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 963",
    transform: "translate(236.953 406.504)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067",
    transform: "translate(2.096 20.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    d: "M-250.2-405.125h-7.335a.69.69 0 0 1-.69-.69.69.69 0 0 1 .69-.69h7.335a.69.69 0 0 1 .69.69.69.69 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 964",
    transform: "translate(258.225 406.504)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068",
    transform: "translate(2.096 17.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    d: "M-257.535-411.1a.69.69 0 0 1-.69-.69v-3.143a.69.69 0 0 1 .69-.69.689.689 0 0 1 .69.69v3.143a.689.689 0 0 1-.69.69z",
    fill: "#ff7557",
    "data-name": "Path 965",
    transform: "translate(258.225 415.62)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamic);
export default __webpack_public_path__ + "static/media/Dynamic.fc5000c605f07268e767d237c9387624.svg";
export { ForwardRef as ReactComponent };